import type { ReactNode } from "react";
import styled from "styled-components";
import { NewAuthLayout } from "../NewAuthLayout";
import type { RoleRegisterStep } from "./RoleRegister.types";

const EmailText = styled.strong`
	display: inline;
	font-weight: 600;
	color: #3a0ca3;
`;

interface RoleRegisterLayoutProps {
	step: RoleRegisterStep;
	email: string;
	error: string;
	emailError: string;
	onBack: () => void;
	children: ReactNode;
}

const stepHeader = ({
	step,
	email,
}: Pick<RoleRegisterLayoutProps, "step" | "email">): {
	title: string;
	subtitle: ReactNode;
} => {
	if (step === "verify") {
		return {
			title: "Verify your email",
			subtitle: (
				<>
					We’ve sent a 6-digit code to <EmailText>{email}</EmailText>
				</>
			),
		};
	}

	if (step === "persona") {
		return { title: "Sign up as...", subtitle: "Set up your Creatorverse account" };
	}

	return { title: "Creator Sign-up", subtitle: "Create your Creatorverse account." };
};

export const RoleRegisterLayout = ({ step, email, error, emailError, onBack, children }: RoleRegisterLayoutProps) => {
	const header = stepHeader({ step, email });
	return (
		<NewAuthLayout
			title={header.title}
			subtitle={header.subtitle}
			error={error && !emailError && step !== "verify" ? error : undefined}
			showBack
			onBack={onBack}
			topPadding={step === "persona" || step === "details" ? 40 : undefined}
			bottomPadding={step === "persona" ? 64 : step === "details" ? 32 : undefined}
			backMarginBottom={step === "details" ? 16 : step === "persona" ? 30 : undefined}
			backColor={step === "details" ? "#707070" : undefined}
			headerMarginBottom={step === "persona" ? 35 : undefined}
			hideHeader={step === "details"}
			reserveScrollbarGutter
		>
			{children}
		</NewAuthLayout>
	);
};
